import { ui } from "../../interfaces/interfaces";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React from "react";
import useDebugInformation from "../../hooks/useDebugInformation";
import { AddressPrefix } from "@utils/BasicTypes";
import { Paper } from "@mui/material";
import { useAppSelector } from "@store/hooks";

const name = "AddressSwitch"

type Props = {
  prefix: Exclude<AddressPrefix, "RelatedAddress" | "LandlordAddress" | "PropertyAddress">
  parent: string
}

const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean, prefix: Props["prefix"]) => {
  ui[`${prefix}AsProperty`] = checked
}

const AddressSwitch: React.FC<Props> = ({ prefix, parent }) => {
  const asProperty = useAppSelector(({ ui }) => ui[`${prefix}AsProperty`])
  const debugName = `[${parent}]▷[${name}]`

  useDebugInformation(debugName, { prefix, asProperty, parent })
  return (
    <Paper elevation={1} sx={{ p: .5, borderRadius: ".5rem", position: "relative" }}>
      <FormGroup row sx={{ mb: 0, pb: 0 }}>
        <FormControlLabel
          control={<Switch checked={asProperty ? asProperty : false} onChange={(event, checked) => handleSwitchChange(event, checked, prefix)} name={`AsProperty`} color="primary" />}
          label="Same as property"
          style={{ zIndex: 9999 }} sx={{ mb: 0, ml: 0 }}
        />
      </FormGroup>
    </Paper>
  );
}

export default React.memo(AddressSwitch)